<template>
    <v-container fill-height fluid grid-list-xl class="pt-3">
        <v-layout wrap>
            <v-flex xs12 class="px-0">
                <v-card class="mb-4 pb-4">
                    <v-layout column>
                        <v-card-actions class="mb-2 mt-3">
                            <v-layout
                                row
                                wrap
                                v-bind:class="{
                                    'pl-0': isMobile(),
                                    'pl-3': !isMobile(),
                                }"
                            >
                                <v-flex
                                    md5
                                    xs12
                                    class="pl-2"
                                    v-bind="{ 'py-0': isMobile() }"
                                >
                                    <v-card-text
                                        class="pl-2 font-weight-regular"
                                        >Search By Name</v-card-text
                                    >
                                    <v-layout row class="pl-3 mr-2">
                                        <v-text-field
                                            outline
                                            class="mr-2"
                                            autocomplete="new-password"
                                            label="Last Name"
                                            v-model="lastNameSearch"
                                            @input="searchByName"
                                            :hide-details="isMobile()"
                                        ></v-text-field>
                                        <v-text-field
                                            outline
                                            autocomplete="new-password"
                                            label="First Name"
                                            v-model="firstNameSearch"
                                            @input="searchByName"
                                            :hide-details="isMobile()"
                                        ></v-text-field>
                                    </v-layout>
                                </v-flex>
                                <v-flex md3 xs12>
                                    <v-card-text
                                        v-bind:class="{
                                            'pl-1': isMobile(),
                                            'pl-0': !isMobile(),
                                        }"
                                        class=" font-weight-regular"
                                        >Search By Phone Number</v-card-text
                                    >
                                    <v-layout row>
                                        <v-text-field
                                            v-bind:class="{
                                                'ml-2': isMobile(),
                                            }"
                                            autocomplete="new-password"
                                            outline
                                            class="ml-3 mr-2"
                                            label="Phone Number"
                                            v-model="phoneSearch"
                                            mask="###-###-####"
                                            @input="searchByPhone"
                                        ></v-text-field>
                                    </v-layout>
                                </v-flex>
                                <v-flex md3 xs12>
                                    <v-card-text
                                        v-bind:class="{
                                            'pl-1': isMobile(),
                                            'pl-0': !isMobile(),
                                        }"
                                        class=" font-weight-regular"
                                        >Building</v-card-text
                                    >
                                    <v-layout row>
                                        <v-select
                                            v-bind:class="{
                                                'ml-2': isMobile(),
                                            }"
                                            outline
                                            class="ml-3 mr-4"
                                            label="Building"
                                            v-model="building"
                                            :items="buildings"
                                            @change="buildingChanged"
                                        ></v-select>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-card-actions>
                        <v-layout
                            class="mx-4 my-2 headline font-weight-medium"
                            row
                            v-if="accounts && accounts.length && !isMobile()"
                        >
                            <div style="width: 15%">Last Name</div>
                            <div style="width: 15%">First Name</div>
                            <div style="width: 20%">
                                Home Phone
                            </div>
                            <div style="width: 20%">
                                Cell Phone
                            </div>
                            <div style="width: 20%">Address</div>
                        </v-layout>
                        <v-layout
                            class="mx-4 my-2"
                            style="border: #999 2px solid; padding: 10px; cursor: pointer;"
                            row
                            @click="selectAccount(account)"
                            v-if="accounts && accounts.length && !isMobile()"
                            v-for="(account, index) in accounts"
                        >
                            <div style="width: 15%">{{ account.lastName }}</div>
                            <div style="width: 15%">
                                {{ account.engName }}
                            </div>
                            <div style="width: 20%">
                                {{ account.homePhone }}
                            </div>
                            <div style="width: 20%">
                                {{ account.cellPhone }}
                            </div>
                            <div style="width: 20%">{{ account.address1 }}</div>
                        </v-layout>
                        <v-layout
                            class="mx-4 my-2"
                            style="border: #999 2px solid; padding: 10px; cursor: pointer;"
                            column
                            @click="selectAccount(account)"
                            v-if="accounts && accounts.length && isMobile()"
                            v-for="(account, index) in accounts"
                        >
                            <div class="font-weight-medium">
                                {{
                                    account.lastName + ", " + account.engName
                                }}
                            </div>
                            <div>
                                {{ account.homePhone }}
                            </div>
                            <div>
                                {{ account.cellPhone }}
                            </div>
                            <div>{{ account.address1 }}</div>
                        </v-layout>
                        <div
                            class="mt-2 mb-3 font-weight-regular text-xs-center text-warning headline"
                            v-if="
                                showNoAccountsMessage &&
                                    !accounts.length &&
                                    !account.accountID
                            "
                        >
                            No Accounts Found
                        </div>
                        <v-layout row justify-space-between>
                            <div
                                v-if="account.accountID && !accounts.length"
                                class="mb-3 pl-3"
                            >
                                <v-flex xs12 class="pt-0">
                                    <v-layout row>
                                        <v-layout
                                            column
                                            v-bind:class="{
                                                'ml-2': isMobile(),
                                                'ml-4': !isMobile(),
                                            }"
                                        >
                                            <v-card-title
                                                primary-title
                                                class="pt-0 py-0 mt-3"
                                            >
                                                <div>
                                                    <h3
                                                        style="font-weight: 500 !important;"
                                                        class="headline my-0"
                                                    >
                                                        Account ID:
                                                        {{ account.accountID }}
                                                    </h3>
                                                </div>
                                            </v-card-title>
                                            <v-card-text class="mb-2 pt-0">
                                                <h4
                                                    class="card-title font-weight-regular"
                                                >
                                                    {{ account.name }}
                                                </h4>
                                                <p>
                                                    {{ account.hname }}
                                                </p>
                                                <p>
                                                    {{ account.address1 }}
                                                </p>
                                            </v-card-text>
                                            <div class="ml-4 pl-1 mt-0">
                                                <v-layout row class="mb-2">
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Home:
                                                    </div>
                                                    <div>
                                                        {{ account.homePhone }}
                                                    </div>
                                                </v-layout>
                                                <v-layout row class="mb-2">
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Cell:
                                                    </div>
                                                    <div>
                                                        {{ account.cellPhone }}
                                                    </div>
                                                </v-layout>
                                                <v-layout row class="mb-4">
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Email:
                                                    </div>
                                                    <div>
                                                        {{
                                                            account.emailAddress
                                                        }}
                                                    </div>
                                                </v-layout>
                                            </div>
                                        </v-layout>
                                    </v-layout>
                                </v-flex>
                            </div>
                            <v-spacer></v-spacer>
                        </v-layout>
                    </v-layout>
                </v-card>

                <v-card
                    v-if="students.length && !accounts.length"
                    class="pa-3 pt-4 pb-0 mt-4"
                >
                    <div
                        class="font-weight-light headline pb-3"
                        style=""
                        v-if="!isMobile()"
                    >
                        <v-layout row class="pl-3 pt-2">
                            <div style="width: 30%">STUDENT</div>
                            <div class="ml-3" style="width: 10%">GRADE</div>
                            <div class="ml-3" style="width: 10%">
                                SECTION
                            </div>
                            <div class="ml-3" style="width: 50%"></div>
                        </v-layout>

                        <v-divider
                            style="border: 2px solid #999"
                            class="my-3"
                        ></v-divider>
                    </div>
                    <div
                        class="font-weight-medium pb-3"
                        v-bind:class="{
                            'display-1': !isMobile(),
                            title: isMobile(),
                        }"
                        v-for="(student, index) in students"
                    >
                        <v-layout row class="pl-3" v-if="!isMobile()">
                            <div style="width: 30%">
                                {{ student.engName }}
                            </div>
                            <div style="width: 10%" class="ml-3">
                                {{ student.class }}
                            </div>
                            <div style="width: 10%" class="ml-3">
                                {{ student.section }}
                            </div>
                            <div style="width: 45%" class="ml-3">
                                <v-layout row>
                                    <v-text-field
                                        class="mr-4 mt-2"
                                        hide-details
                                        label="Note"
                                        v-model="student.note"
                                        ref="note"
                                    ></v-text-field>
                                    <v-btn color="success" dark class="mr-4 ml-3" @click="saveTest(student)">Save Test</v-btn>
                                </v-layout>
                            </div>
                        </v-layout>

                        <v-layout column style="width: 40%" class="font-weight-light ml-0 body-2 ml-0 pl-1" v-if="getStudentTests(student).length">
                            <div class="title font-weight-medium pl-1 ml-0 pb-1 mt-1">Previous Tests:</div>

                            <div v-for="(test, index) in getStudentTests(student)">
                                <v-layout row style="height: 23px;" class="mb-0 ml-1">
                                    <div class="mr-4">
                                        <span class="font-weight-medium">Date</span>: {{test.date | time }}
                                    </div>
                                    <div class="ml-3" v-if="test.note">
                                        <span class="font-weight-medium">Note</span>: {{test.note }}
                                    </div>
                                </v-layout>
                                <v-divider
                                    class="my-2"
                                    v-if="index + 1 < getStudentTests(student).length"
                                ></v-divider>
                            </div>
                        </v-layout>

                        <v-layout column class="pl-3" v-if="isMobile()">
                            <div>
                                {{ student.engName }}
                            </div>
                            <div class="mt-1" v-if="student.class">
                                Grade:
                            </div>
                            <div class="font-weight-light">
                                {{ student.class }}
                            </div>
                            <div class="mt-1" v-if="student.section">
                                Section:
                            </div>
                            <div class="font-weight-light">
                                {{ student.section }}
                            </div>
                        </v-layout>

                        <v-divider
                            class="mt-3"
                            v-if="index + 1 < students.length"
                        ></v-divider>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="searchDialog" max-width="1400">
            <v-card>
                <data-grid
                    class="accounts-search"
                    url="accounts"
                    :columns="accountsColumns"
                    :title="searchDialogTitle"
                    navigationPath="Account View"
                    navigationField="accountID"
                    v-bind:hideActions="true"
                    :onRowClicked="onSearchAccountsRowClicked"
                ></data-grid>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import vueSelect2 from "vue-select";
import { getDomain, sum, groupBy } from "../../utils/helpers.js";
import odata from "odata-client";
import { loadOptions } from "../../utils/smLookup.js";
import moment from "moment";

export default {
    components: {
        "vue-select2": vueSelect2,
    },
    data: () => ({
        phoneSearch: "718",
        firstNameSearch: "",
        lastNameSearch: "",
        accounts: [],

        account: {},

        students: [],
        studentList: [],
        buildings: [],
        building: '',

        searchDialogTitle: "Accounts",
        searchDialog: false,
        showNoAccountsMessage: false,

        accountsColumns: [
            {
                sortable: true,
                label: "Name",
                field: "name",
                hidden: false,
                width: "200px",
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Name..",
                },
            },
            {
                sortable: false,
                label: "Account ID",
                field: "accountID",
                width: "115px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Account ID..",
                },
            },
            {
                sortable: false,
                label: "Hebrew Name",
                width: "250px",
                field: "hname",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Hebrew Name..",
                },
            },
            {
                sortable: false,
                label: "Home Phone",
                field: "homePhone",
                width: "150px",
                hidden: false,
                searchValue: (value) => {
                    return value.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
                },
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Home Phone..",
                },
            },
            {
                sortable: false,
                label: "Cellphone",
                field: "cellPhone",
                width: "150px",
                hidden: false,
                searchValue: (value) => {
                    return value.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
                },
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Cellphone..",
                },
            },
            {
                sortable: false,
                label: "Address",
                field: "address1",
                width: "200px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Address..",
                },
            },
            {
                sortable: false,
                label: "Email",
                field: "emailAddress",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Father",
                field: "father",
                hidden: true,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Shver",
                field: "shver",
                hidden: true,
                filterOptions: {
                    enabled: true,
                },
            },
        ],
    }),
    async created() {
        this.loadBuildings();
    },
    methods: {
        async loadBuildings() {
            const buildings = await this.$http.get('api/covidtests/GetBuildings');

            this.buildings = buildings.filter(Boolean);

            const building = localStorage.getItem("covid-test-building-filter");

            this.building = building || this.buildings[0];
        },
        isMobile() {
            return this.$vuetify.breakpoint.name == "xs";
        },
        onSearchAccounts(search, loading) {
            loading(true);

            this.searchAccounts(loading, search);
        },
        async saveTest(student) {
            try {
                await this.$http.post('api/covidtests/saveTest', {
                    studentID: student.studentID,
                    note: student.note,
                });

                await this.loadTests();

                this.students = this.studentList.filter(s => s.building == this.building);
            } catch(e) {}
        },
        async loadTests() {
            const tests = await this.$http.get('api/covidtests/getCovidTests?accountID=' + this.account.accountID);

            this.studentList.forEach(student => {
                student.tests = tests.filter(t => t.studentID.trim() == student.studentID.trim());
            });
        },
        async searchAccounts(loading, searchTerm) {
            const request = odata({
                service: getDomain() + "/odata/",
                resources: "accounts",
            }).top(30);

            if (searchTerm) {
                request.filter(`startswith(lastname, '${searchTerm}')`);
            }

            const response = await request.get();

            this.accounts = JSON.parse(response.body).value.map((account) => {
                account.displayName = this.getDisplayName(account);

                return account;
            });

            loading(false);
        },
        onSearchAccountsRowClicked(account) {
            this.searchDialog = false;

            account.displayName = this.getDisplayName(account);

            this.account = account;

            this.onAccountSelected();
        },
        getDisplayName(account) {
            return (
                account.lastName +
                " " +
                account.firstName +
                " (" +
                account.address1 +
                ")"
            );
        },
        getStudentTests(student) {
            return this.studentList.find(s => s.studentID.trim() == student.studentID.trim()).tests || [];
        },
        async searchByPhone(value) {
            if (value.length < 10) return;

            const account = await this.$http.get(
                `api/lapidusDayCamp/getAccountByPhoneNumber?phoneNumber=${value}`
            );

            if (!account) {
                this.$notify({
                    text: "Account Does Not Exist",
                    group: "notification",
                    type: "warning",
                });

                this.clearSelection();
                this.accounts = [];

                return;
            }

            this.account = account;

            this.onAccountSelected();
        },
        buildingChanged(value) {
            this.students = this.studentList.filter(s => s.building == value);

            localStorage.setItem("covid-test-building-filter", value);

            if (!this.students.length && this.building && this.account.accountID) {
                this.$notify({
                    text: "No students in this building found for this account.",
                    group: "notification",
                    type: "warning",
                });
            }
        },
        async searchByName(value) {
            if (!this.firstNameSearch && !this.lastNameSearch) {
                this.clearSelection();
                this.accounts = accounts;

                return;
            }

            this.showNoAccountsMessage = false;

            const accounts = await this.$http.get(
                `api/covidtests/GetStudentsByName?last=${
                    this.lastNameSearch
                }&first=${this.firstNameSearch}&building=${this.building}`
            );

            if (!accounts.length) {
                this.showNoAccountsMessage = true;
                this.clearSelection();
                this.accounts = accounts;

                return;
            }

            if (accounts.length == 1) {
                this.account = accounts[0];

                this.onAccountSelected();
            } else {
                this.accounts = accounts;
            }
        },
        async searchByLastName(value) {
            if (!value) {
                this.account = {};

                return;
            }

            this.showNoAccountsMessage = false;

            const accounts = await this.$http.get(
                `api/daycamp/getAccountsByLastName?name=${value}`
            );

            if (!accounts.length) {
                this.showNoAccountsMessage = true;
                this.clearSelection();
                this.accounts = accounts;

                return;
            }

            if (accounts.length == 1) {
                this.account = accounts[0];

                this.onAccountSelected();
            } else {
                if (!this.accounts.length) {
                    this.clearSelection();
                }
                this.accounts = accounts;
            }
        },
        async onSelected(account) {
            if (!account) {
                return this.clearSelection();
            }

            this.accounts = [];

            this.onAccountSelected();
        },
        clearSelection() {
            this.phoneSearch = "718";
            this.students = [];
            this.studentList = [];
            this.account = {};
        },
        async onAccountSelected() {
            this.students = [];
            this.studentList = [];
            this.accounts = [];
            this.firstNameSearch = "";
            this.lastNameSearch = "";
            this.phoneSearch = "718";

            this.loadStudets();
        },
        selectAccount(account) {
            this.account = account;
            this.accounts = [];
            this.onAccountSelected();
        },
        async loadStudets() {
            const students = await this.$http.get(
                "api/accounts/getStudents?accountID=" +
                    this.account.accountID
            );

            this.studentList = students.map(student => {
                student.note = '';

                return student;
            });

            await this.loadTests();

            this.students = this.studentList.filter(s => s.building == this.building);

            if (!this.students.length && this.building) {
                this.$notify({
                    text: "No students in this building found for this account.",
                    group: "notification",
                    type: "warning",
                });
            }
        },
    },
};
</script>
